import RawHtml from '@components/RawHtml';
import { WagtailImage } from '@/types';
import Image from 'next/image';
import { addBaseUrl } from '@/utils/url';

interface Props {
  title: string;
  subtitle?: string | null;
  text?: string | null;
  banner_icon_svg?: string | null;
  banner_icon_png?: WagtailImage | null;
}

function Hero(props: Props) {
  const {
    title,
    subtitle,
    text,
    banner_icon_svg: bannerIconSvg,
    banner_icon_png: bannerIconPng,
  } = props;

  return (
    <div role='banner' className='hero flow'>
      {bannerIconPng && !bannerIconSvg ? (
        <div className='hero__icon'>
          <Image
            src={addBaseUrl(bannerIconPng.meta.download_url)}
            alt={bannerIconPng.title}
            layout='intrinsic'
            objectFit='contain'
            className='icon'
            width={78}
            height={78}
          />
        </div>
      ) : null}
      {bannerIconSvg ? <RawHtml className='hero__icon' html={bannerIconSvg} /> : null}
      <h1 className='hero__title'>{title}</h1>
      {subtitle ? <h2 className='hero__subtitle'>{subtitle}</h2> : null}
      {text ? <RawHtml className='hero__text' html={text} /> : null}
    </div>
  );
}

export default Hero;
